import axios from "axios";
import { GENERAL_URL_API } from "../urls";

const RECOMENDACION_URL = `${GENERAL_URL_API}/recomendacion`;
const EDITAR_PLANTILLAS_URL = `${RECOMENDACION_URL}/editarPlantillas.php`;

/**
 * Lista las plantillas guardadas del recomendador.
 * @param {string} [superInstituto] - Limita el listado a un Super Instituto.
 * @returns {Promise<Array>} Plantillas con su `config` ya deserializado.
 */
export async function fetchPlantillas(superInstituto = "") {
  const fd = new FormData();
  if (superInstituto) fd.append("superInstituto", superInstituto);

  const { data } = await axios.post(
    `${RECOMENDACION_URL}/verPlantillas.php`,
    fd,
    { withCredentials: true }
  );

  return data?.data ?? [];
}

/**
 * Guarda una nueva plantilla con la configuración actual.
 * @param {Object} options
 * @param {string} options.nombre
 * @param {Object} options.config - Configuración completa del recomendador.
 */
export async function createPlantilla({ nombre, config }) {
  const fd = new FormData();
  fd.append("editionType", "crear");
  fd.append("nombre", nombre);
  fd.append("config", JSON.stringify(config));

  const { data } = await axios.post(EDITAR_PLANTILLAS_URL, fd, {
    withCredentials: true,
  });

  return data;
}

/**
 * Sobrescribe una plantilla existente.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {string} options.nombre
 * @param {Object} options.config
 */
export async function editPlantilla({ id, nombre, config }) {
  const fd = new FormData();
  fd.append("editionType", "editar");
  fd.append("id", id);
  fd.append("nombre", nombre);
  fd.append("config", JSON.stringify(config));

  const { data } = await axios.post(EDITAR_PLANTILLAS_URL, fd, {
    withCredentials: true,
  });

  return data;
}

/**
 * Elimina una plantilla guardada.
 * @param {number|string} id
 */
export async function deletePlantilla(id) {
  const fd = new FormData();
  fd.append("editionType", "eliminar");
  fd.append("id", id);

  const { data } = await axios.post(EDITAR_PLANTILLAS_URL, fd, {
    withCredentials: true,
  });

  return data;
}
